module.exports = "<script type=\"text/javascript\">\nvar qp = null;\nif (window.location.hash) {\n  qp = location.hash.substring(1);\n} else {\n  qp = location.search.substring(1);\n}\nqp = !qp ? {} : JSON.parse('{\"' + qp.replace(/&/g, '\",\"').replace(/=/g,'\":\"') + '\"}',\n  function(key, value) {\n    return key===\"\" ? value : decodeURIComponent(value);\n  })\n\nwindow.opener.onOAuthComplete(qp);\n\nwindow.close();\n</script>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/views/oauth_callback.html
// module id = ./src/app/views/oauth_callback.html
// module chunks = main